<template>
  <div class="film">
    <div class="images">
      <!-- 轮播图 -->
      <loop-play-images
        v-if="bannerImagesData != null"
        :default-classes="defaultClasses"
        :images-data="bannerImagesData"
        :background-appe-mode="false"
      />
    </div>
    <div class="popular" style="z-index: -1"></div>
    <!-- 分类搜索 -->
    <category-search-com
      :category-search-data="menuList"
      @categorySearchItemClick="categorySearchItemClick"
    />
    <!-- 图片列表 -->
    <div class="main">
      <imageList :info="imageListInfo" @movieClick="imageListMovieClick" />
    </div>
    <div class="empty" v-show="!query.totalElements" style="text-align: center">
      <img src="../assets/images/no_data.png" alt="" />
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :page-size="query.pageSize"
        :total="query.totalElements"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
  <!-- <div class="advertisement" v-if="bottomBanner">
      <a :href="`${bottomBanner.link}`" target="_blank">
        <img :src="bottomBanner.image" :alt="bottomBanner.title" />
      </a>
    </div> -->
</template>

<script>
import loopPlayImages from "@/components/loopPlayImages/loopPlayImages.vue";
import imageList from "@/components/gaoyinghao/imageListOld.vue";
import categorySearchCom from "@/components/zhangqi/CategorySearchCom.vue";
import bus from "@/utils/eventBus";
export default {
  components: {
    loopPlayImages,
    categorySearchCom,
    imageList,
  },
  data() {
    return {
      keywordKey: null,
      keywordVal: null,
      // 轮播图
      defaultClasses: {
        outerRotateStage: "loopImages",
        rotateStageClass: "loopStage",
        innerShowClass: "loopContainer",
        btnClass: "btnOuter",
        circularClass: "dots",
      },
      bannerImagesData: null,
      bottomBanner: null,
      // 分类搜索
      menuList: [],
      // 图片列表
      imageListInfo: {
        type: "free",
        title: "搜索列表",
        icon: require("../assets/icon/host.png"),
        list: [],
      },
      query: {
        pageSize: 14, // 每页几条数据
        totalElements: 0, // 总条数
        pageNum: 0, // 第几页
        orderByField: "updatedTime", // 排序
        orderByType: "DESC", // 排序
      },
    };
  },
  mounted() {
    // 第一次点击顶栏搜索按钮跳转到搜索页面需要查找的关键词
    if (this.searchText) this.query.videoName = this.searchText;
    if (this.searchField) {
      try {
        Object.assign(this.query, JSON.parse(this.searchField));
      } catch (ignore) {
        // do nothing
      }
    }
    // 进入搜索页面后点击顶栏搜索按钮
    var _this = this;
    bus.$on("searchEvent", function (videoName) {
      _this.query.videoName = videoName;
      _this.getImageListData();
    });
    bus.$emit("updateFooter", "搜索");
    // 获取banner数据
    this.getBannerData();
    // 获取图片列表
    this.getImageListData();
    // 获取分类搜索数据
    this.getSearchData();
  },
  computed: {
    searchText: function () {
      return this.$route.query.searchText;
    },
    searchField: function () {
      return this.$route.query.searchField;
    },
  },
  methods: {
    // 获取banner数据
    getBannerData() {
      var _this = this;
      this.$axios({
        url: "/realNet/pageManager/findOne",
        method: "get",
        headers: { token: "123456789" },
        params: {
          title: "搜索",
        },
      })
        .then((res) => {
          var bannerList = res.data.result.dataMap.bannerList;
          let bottomBanner = res.data.result.dataMap.bottomBanner;
          _this.bottomBanner = bottomBanner ? bottomBanner[0] : null;
          _this.bannerImagesData = bannerList.map((item) => {
            return {
              backgroundImage: item.image,
              imageLinkRouterName: item.link,
            };
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 获取图片列表
    getImageListData(val, keyword, resetKeyword) {
      if (keyword) {
        this.keywordKey = "categoryId";
        this.keywordVal = val[this.keywordKey];
        if (val[this.keywordKey] === keyword[this.keywordKey]) {
          this.keywordVal = null;
        }
      }
      resetKeyword && (this.keywordVal = null);
      var _this = this;

      this.$axios({
        url: this.keywordVal
          ? `/realNet/video/getVideoInfos?${this.keywordKey}=${this.keywordVal}`
          : "/realNet/video/getVideoInfos",
        method: "get",
        headers: { token: "123456789" },
        params: this.query,
      })
        .then((res) => {
          var result = res.data.result;
          var searchResult = [];
          result.content.map((videoInfo, index) => {
            console.log(index);
            if (index == 0) {
              searchResult.push({
                id: videoInfo.id,
                img: videoInfo.horizontalImage,
                name: videoInfo.videoName,
                intro: videoInfo.description ? videoInfo.description : "",
                grade: videoInfo.score ? videoInfo.score : 6,
                detailPage: videoInfo.isRmhdDownload
                  ? "DownloadDetailPage"
                  : "TVplayPage",
                protagonist: videoInfo.protagonist,
              });
            } else {
              searchResult.push({
                id: videoInfo.id,
                img: videoInfo.verticalImage,
                name: videoInfo.videoName,
                intro: videoInfo.description ? videoInfo.description : "",
                grade: videoInfo.score ? videoInfo.score : 6,
                detailPage: videoInfo.isRmhdDownload
                  ? "DownloadDetailPage"
                  : "TVplayPage",
                protagonist: videoInfo.protagonist,
              });
            }
          });
          _this.$set(_this.imageListInfo, "list", searchResult);
          _this.query.totalElements = result.totalElements;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 获取分类搜索数据
    getSearchData() {
      var _this = this;
      this.$axios({
        url: "/realNet/pageManager/findOne",
        method: "get",
        headers: { token: "123456789" },
        params: {
          title: "搜索",
        },
      })
        .then((res) => {
          _this.menuList = res.data.result.dataMap.menuList;
          _this.menuList.forEach((item) => {
            var isActive = false;
            if (_this.searchField) {
              item.menuList.some((subItem) => {
                if (
                  subItem.searchField &&
                  _this.searchField.indexOf(
                    subItem.searchField.substr(
                      1,
                      subItem.searchField.length - 2
                    )
                  ) > -1
                ) {
                  subItem.isActive = isActive = true;
                  return isActive;
                }
              });
            }

            item.menuList = [
              {
                name: "全部",
                searchField: {},
                isActive: !isActive,
              },
            ].concat(item.menuList);
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 当前页数改变时，调用该函数
    handleCurrentChange(val) {
      try {
        if (document.documentElement.scrollTop)
          document.documentElement.scrollTop = 750;
        if (document.body.scrollTop) document.body.scrollTop = 750;
        if (window.pageYOffset) window.pageYOffset = 750;
      } catch (e) {
        // ignore error.
      }

      this.query.pageNum = val - 1;
      this.getImageListData();
    },
    // 排序
    sortChange(val) {
      this.query.orderByField = val;
      this.query.orderByType =
        this.query.orderByField == "videoName" ? "ASC" : "DESC";
      this.getImageListData();
    },
    // 分类搜索的按钮
    categorySearchItemClick(val, keyword, resetKeyword) {
      this.query = Object.assign(
        {
          pageSize: 14, // 每页几条数据
          totalElements: 0, // 总条数
          pageNum: 0, // 第几页
          orderByField: this.query.orderByField, // 排序
          orderByType: this.query.orderByType, // 排序
          videoName: this.searchText, // 视频名称
        },
        val,
        keyword
      );
      this.getImageListData(val, keyword, resetKeyword);
    },
    imageListMovieClick(option) {
      bus.$emit("clearSearchText");
      this.$router.push({
        name: option.infoItem.detailPage,
        query: {
          contentId: option.infoItem.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.searchPage {
  width: 90%;
  margin: 0 auto;
  .searchPageSort {
    margin-top: 25px;
    padding: 15px;
    background-color: #f3f7f8;
    .searchPageSortTitle {
      font-size: 14px;
      margin-right: 30px;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #3bc0d0;
      background-color: #3bc0d0;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #3bc0d0;
    }
  }
  .searchPageImageList {
    margin-top: 25px;
    .imageList {
      width: 100%;
      .title {
        display: none;
      }
    }
  }
  .searchPagePagination {
    text-align: center;
    margin-bottom: 40px;
    .el-pagination {
      display: inline-block;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #3bc0d0;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
      color: #fff;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #3bc0d0;
    }
    .el-pagination button,
    .el-pagination span:not([class*="suffix"]) {
      padding: 0 4px;
    }
  }
  .empty {
    text-align: center;
  }
}
.advertisement {
  margin-top: 28px;
  width: 100%;
  a > img {
    width: 100%;
    height: auto;
  }
}
.film .btnOuter,
.film .dots {
  display: none;
}
.film .loopImages {
  height: 640px !important;
}
</style>



